import type { RouteRecordRaw } from 'vue-router'

import AccessDeniedPage from '../pages/AccessDeniedPage.vue'
import DashboardPage from '../pages/DashboardPage.vue'

import { AppRoutes } from '@/enums/app-routes.enum.ts'

const routes: RouteRecordRaw[] = [
  {
    path: '/:lang/dashboard',
    component: DashboardPage,
    name: AppRoutes.DASHBOARD,
  },
  {
    path: '/:lang/access-denied',
    component: AccessDeniedPage,
    name: AppRoutes.ACCESS_DENIED,
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/en/dashboard',
  },
]

export default routes
